EASY.schedule.main(function () {
  ERUI.content.on("change", "input[data-disables], input[data-enables], input[data-shows]", toggleDisabledOnChange);
  toggleDisabledInit();
  setupAjaxIndicator();
  hideOnLoad();
  addFormObserversForDoubleSubmit();
  setupTabs();
  $("input[type=checkbox].toggle-selection").on("change", function (el) {
    EASY.contextMenu.toggleIssuesSelection(el.target);
  });

  $("#easy_servicebar").servicebarUtils();
  const content = document.getElementById("content");
  const fullScreenBtn = document.querySelector(".fullscreen__trigger");
  new EASY.utils.FullScreen(content, fullScreenBtn).init();

  //$('#wrapper').find('[title]').not('th').customTooltip();
  $("#easy_page_tabs").tabScrollButtons();

  // EASY.utils.toggleMenu is defined in utils/extensions_utils.js — do not redefine here

  // for modal selector
  $.infinitescroll.prototype._nearbottom_modal_selector = function () {
    var opts = this.options;
    return 0.9 < (opts.binder.scrollTop() + opts.binder.height()) / $(opts.contentSelector).height();
  };

  function onScroll() {
    const isInsideIFrame = window.ERUI.body.hasClass("in-iframe");
    if (isInsideIFrame) return;
    ERUI.scrollTopLast = ERUI.scrollTop;
    ERUI.scrollTop = $(window).scrollTop();
    affix.read();
    window.requestAnimationFrame(function () {
      //do stuff
      affix.tableScrolls();
      affix.tableHeads();

      if (ERUI.scrollTop) {
        ERUI.backToTop.css({ opacity: "1" });
      } else {
        ERUI.backToTop.css({ opacity: "0" });
      }
      if (ERUI.sideScrollEl && ERUI.sideScrollEl.length > 0) {
        if (!affix.register["sidebar"].attached) {
          ERUI.sideScrollEl.css({
            height: ERUI.sideScrollElHight + ERUI.scrollTop,
          });
        } else {
          ERUI.sideScrollEl.css({
            height:
              ERUI.window.outerHeight() -
              ERUI.topMenu.outerHeight() -
              affix.sideScrollElOffs -
              affix.sass.boxPadding +
              2,
            //height: ERUI.sideScrollElHight + ERUI.headerHeight - ERUI.sidebarOffsTop + ERUI.onboardHeight
          });
        }
      }
    });
  }

  var responsivizer = EASY.responsivizer;
  responsivizer.init();
  responsivizer.fakeResponsive();
  affix.preInit();
  affix.tableScrolls();
  affix.tableHeads();
  EASY.utils.initAutoscroll();
  ERUI.window.scroll(onScroll);
  ERUI.window.resize(function () {
    window.requestAnimationFrame(function () {
      responsivizer.fakeResponsive();
      affix.reInit();
      affix.tableScrolls();
      responsivizer.contentWidth = $("#content").width();
    });
  });

  ERUI.document.on("erui_new_dom", function (event) {
    ERUI.init();
    responsivizer.init();
    window.requestAnimationFrame(function () {
      responsivizer.fakeResponsive(event.target);
      affix.reInit();
      affix.tableScrolls();
      affix.tableHeads();
      affix.recalculateHeads(ERUI.tableHeads);
      EASY.utils.initAutoscroll();
    });
  });

  ERUI.document.on("erui_interface_change_modal", function () {
    ERUI.document.trigger("erui_new_dom");
  });
  ERUI.document.on("erui_interface_change_vertical", function () {
    responsivizer.fakeResponsive();
    affix.reInit(); // maybe too much workout, but works better with it
    affix.tableScrolls();
    affix.tableHeads();
  });

  ERUI.document.on("cocoon:after-insert", function (e) {
    ERUI.document.trigger("erui_interface_change_vertical");
  });
  ERUI.document.on("cocoon:after-remove", function (e) {
    ERUI.document.trigger("erui_interface_change_vertical");
  });
  ERUI.document.on("tab-change", function (e) {
    ERUI.document.trigger("erui_new_dom");
  });
  ERUI.document.on("easy-query:after-search", function (e) {
    ERUI.document.trigger("erui_new_dom");
  });
  ERUI.document.on("entity-tabs:after-tab-switch", function (e) {
    ERUI.document.trigger("erui_new_dom");
  });
  ERUI.document.on("easy_attendance_autoscroll", function (e) {
    ERUI.init();
    affix.preInit();
  });
});
